import React, {useContext} from 'react';
import PropTypes from 'prop-types'
import makeComparator from '../../../../utils/comparator';
import ProgressBar from '../../../common/ProgressBar';
import './styles.scss';
import {I18nContext} from "../../../../providers/i18n";

const getBackgroundClassName = makeComparator('equal', 'yes-greater', 'no-greater');
const getYesNoClassNames = makeComparator(
  ['equal-answer', 'equal-answer'],
  ['greater-answer', 'smaller-answer'],
  ['smaller-answer', 'greater-answer']
);

const BarChart = props => {
  const { t } = useContext(I18nContext);
  const {noPercentage, yesPercentage, containerClassName} = props;
  const backgroundClassName = getBackgroundClassName(yesPercentage, noPercentage);
  const [yesAnswerClassName, noAnswerClassName] = getYesNoClassNames(yesPercentage, noPercentage);
  return (
    <div className={`BarChart ${backgroundClassName} ${containerClassName}`}>
      <div className={'answers-container'}>
        <div className={`answer ${yesAnswerClassName}`} style={{width: `${yesPercentage}%`}}>
          <span className={'percentage'}> {yesPercentage}%</span>
          <span className={'answer-text'}>{t('yes')}</span>
        </div>
        <div className={`answer ${noAnswerClassName}`} style={{width: `${noPercentage}%`}}>
          <span className={'percentage'}>{noPercentage}%</span>
          <span className={'answer-text'}>{t('no')}</span>
        </div>
      </div>
      <div className={'progress-bar-container'}>
        <ProgressBar filledPercentage={yesPercentage}/>
      </div>
    </div>
  );
};

BarChart.propTypes = {
  containerClassName: PropTypes.string,
  noPercentage: PropTypes.number.isRequired,
  yesPercentage: PropTypes.number.isRequired
}

export default BarChart;
